import React, { useEffect, useState } from "react";
import { NLSWrapper, NCarouselWrapper, NContent } from "./leftSectionStyles";
import LandingBanner1 from "../../assets/neat/landing_page1.svg";
import LandingBanner2 from "../../assets/neat/landing_page2.svg";
import LandingBanner3 from "../../assets/neat/landing_page3.svg";
import QueotesLogo from "../../assets/neat/quotes.svg";
import ProgressBar from "./Progressbar";
import TextFadeAnimation from "./TextFadeAnimation";

const texts = [
  "With you, througout your Journey!",
  "Nurturing Brilliance and Inspiring Dedication in Young Minds",
  "Determination. Progress. Service."
];

const banners = [LandingBanner3, LandingBanner2, LandingBanner1];

export const animationTimeDelay = 5

function LeftSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const lenght = 3;
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % lenght);
    }, 4000);

    return () => clearInterval(interval);
  }, []);
  return (
    <NLSWrapper style={{ position: 'relative', overflow: 'hidden' }}>
       {banners.map((banner, index) => (
        <BackgroundLayer
          key={index}
          src={banner}
          isActive={index === activeIndex}
        />
      ))}
      <NCarouselWrapper style={{ position: 'absolute', zIndex: 2 }}>
        <img src={QueotesLogo} alt="quotes" />
        <TextFadeAnimation
          texts={texts}
          interval={2000}
          activeIndex={activeIndex}
        />
        <div style={{ position: "relative", width: "100%", top: "30px" }}>
          <ProgressBar activeIndex={activeIndex} />
        </div>
      </NCarouselWrapper>
    </NLSWrapper>
  );
}

export default LeftSection;


const BackgroundLayer = ({ src, isActive }) => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundImage: `url(${src})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      opacity: isActive ? 1 : 0,
      transition: 'opacity 1s ease-in-out',
      zIndex: 1
    }}
  />
);